var app = angular.module(
    'shop_search',
    ['uiGmapgoogle-maps', 'ngAutocomplete', 'geolocation'])
  .config(function ($interpolateProvider) {
    $interpolateProvider.startSymbol('{[{').endSymbol('}]}');
  });;

app.factory('positionMap', function() {
  return function(shop, $scope, zoom) {
    $scope.map = {
      center: {
        latitude: shop.latitude,
        longitude: shop.longitude
      },
      zoom: zoom
    }
    var $el = $('.angular-google-map-container');
    $el.height($el.height() + 1);
  }
});

app.factory('setupMapOptions', function() {
  return function($scope) {
    for(var i = 0; i < $scope.shops.length; i++) {
      var count = i + 1,
          shop = $scope.shops[i];
      shop.show = false;
      shop.count = count;
      shop.icon = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld= "+
        count + "|1DAFEC|ffffff";
    }
  }
});

app.factory('userLocation', function() {
  return function($scope, $geolocation) {
     $geolocation.getLocation().then(function(data) {
       $scope.search([
          data.coords.latitude,
          data.coords.longitude
        ].toString(), false);
      });
  }
});

app.factory('locationSearch', function() {
  return function(params, e, $scope, $setupMapOptions, $positionMap,
    $http) {
    if(e){
      e.preventDefault();
    }
    var location = encodeURIComponent(params),
    url = "http://0.0.0.0:3000/company/geo_search?location=" + location +
      "&callback=JSON_CALLBACK";
    $http.jsonp(url).success(function(data) {
      $scope.shops = data;
      if($scope.shops.length > 0) {
        $setupMapOptions($scope);
        $positionMap($scope.shops[0], $scope, 8);
      }
      return false;
    })
  }
});

app.controller('shop_search_controller', ['$scope', '$http',
    'positionMap', 'setupMapOptions', 'geolocation', 'userLocation',
    'locationSearch',
    function($scope, $http, $positionMap, $setupMapOptions, $geolocation,
      userLocation, locationSearch) {
      $scope.shops = [];
      $scope.selected_shop = false;

      $scope.shippingOption = function() {
        var option = this.picker.shippingOption;
        if(option == 'ConsumerDirect') {
          $scope.shopDelivery = false;
        } else {
          $scope.shopDelivery = true;
          setTimeout(function(){
            console.log('redraw')
            google.maps.event.trigger($scope.map, 'resize');
          }, 2000)
        }
      }

      $positionMap({ latitude: 45, longitude: -73 }, $scope, 3);
      //google places options
      $scope.gplaces_options = {
        types: '(cities)'
      };

      userLocation($scope, $geolocation);
      $scope.changeCurrentShop = function (shop) {
        $scope.current_shop = shop;
      }

      $scope.search = function(params, e) {
        locationSearch(params, e, $scope, $setupMapOptions, $positionMap, $http)
      };
    }
]);
